/* -------------------------------------------
 * normalizeWeapon
 * Pure function — NO hooks, NO side effects
 * ------------------------------------------ */

const toNumber = (v) => {
    if (typeof v === "number" && Number.isFinite(v)) return v;
    if (typeof v === "string") {
        const n = Number(v.replace(/[^\d.]/g, ""));
        return Number.isFinite(n) ? n : null;
    }
    return null;
};

const toString = (v) =>
    typeof v === "string" && v.trim() ? v.trim() : null;

const toArray = (v) => {
    if (Array.isArray(v)) return v.filter(Boolean);
    if (typeof v === "string")
        return v
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);
    return [];
};

const firstImage = (...vals) =>
    vals.find((v) => typeof v === "string" && v.trim()) || null;

export function normalizeWeapon(raw = {}) {
    const gallery = Array.isArray(raw.gallery)
        ? raw.gallery.filter(Boolean)
        : [];

    const image = firstImage(
        raw.coverUrl,
        raw.coverImage,
        raw.portrait,
        gallery[0],
        raw.image,
        raw.imageUrl
    );

    return {
        /* ---------- identity ---------- */
        name: toString(raw.name) || "Unnamed Weapon",
        category: toString(raw.category),
        type: toString(raw.type),
        manufacturer: toString(raw.manufacturer),

        /* ---------- pricing ---------- */
        price: toNumber(raw.price),

        /* ---------- ammo ---------- */
        ammoType: toString(raw.ammoType),
        magazineSize: toNumber(raw.magazineSize),
        reloadTime: toNumber(raw.reloadTime),

        /* ---------- combat stats ---------- */
        damage: toNumber(raw.damage),
        fireRate: toNumber(raw.fireRate),
        accuracy: toNumber(raw.accuracy),
        range: toNumber(raw.range),
        dps: toNumber(raw.dps),

        /* ---------- metadata ---------- */
        gameMode: toString(raw.gameMode) || "story",
        gameKey: toString(raw.gameKey),
        mk2: Boolean(raw.mk2 || raw.isMk2),
        explosive: Boolean(raw.explosive),

        /* ---------- content ---------- */
        description: toString(raw.description),
        acquisition: toString(raw.acquisition),
        notes: toString(raw.notes),

        /* ---------- attachments ---------- */
        attachments: toArray(raw.attachments),
        compatibleMods: toArray(raw.compatibleMods),

        /* ---------- media ---------- */
        portrait: image,
        gallery,
        videoUrl: toString(raw.videoUrl),

        /* ---------- taxonomy ---------- */
        tags: toArray(raw.tags),

        /* ---------- audit ---------- */
        createdAt: raw.createdAt ?? null,
        updatedAt: raw.updatedAt ?? null,
        authorUid: raw.authorUid ?? raw.createdBy ?? null,
        isPrivate: Boolean(raw.isPrivate ?? raw.isHidden ?? false),
    };
}
